import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormField } from "../../models/vnext.models";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

@Component({
    selector: 'se-anamnestic-data',
    templateUrl: './anamnestic-data.component.html',
    styleUrl: './anamnestic-data.component.scss',
    standalone: false
})
export class AnamnesticDataComponent implements OnChanges {

    @Input() fields : FormField[] = [];
    @Input() formGroup! : FormGroup;
    @Input() isReadonly ?: boolean = true;
    @Input() loading ?: boolean = false;
 
    anamnesticParams : Map<string, any> = new Map();
    constructor (private fb : FormBuilder) {
    }

    ngOnChanges (changes : SimpleChanges) : void {
        if (changes && this.formGroup) {
            this.createAndUpdateControls();
        }
    }

    private createAndUpdateControls () {
        this.fields.forEach(field => {
            const control = this.createControl(field);
            this.formGroup.addControl(field.guid, control);
        });
        this.formGroup.updateValueAndValidity({ onlySelf: true, emitEvent: true });
    }

    private getFieldValue (field : any) : any {
        switch (field.type) {
            case 2:
            case 6:
            case 7:
                return field.value != null ? field.value : 0;
            case 4: // checkbox
                return String(field.value).toLowerCase() === 'true';
            case 9: // date
                if (!field.value) return null;
                return this.convertDate(field.value);
            case 12: // date-time
                if (!field.value) return null;
                return this.convertDateTime(field.value)
            default:
                return field.value ? field.value : '-';
        }
    }

    private convertDateTime(value : string) {
        const parts = value.split(/[/ :]/);
        if (parts.length < 6) return null;
        const [day, month, year, hour, minute] = parts;
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T${hour.padStart(2, '0')}:${minute.padStart(2, '0')}`;
    }

    private convertDate(value : string) {
        const [day, month, year] = value.split(" ")[0].split("/");
        return new Date(+year, +month - 1, +day);
    }

    private createControl (field : FormField) {
        const control = this.fb.control(
            { value: this.isReadonly ? this.getFieldValue(field) : null, disabled: this.isReadonly },
            this.getValidators(field)
        );
        return control;
    }

    private getValidators (field : FormField) {
        const validators = [];

        if (field.isMandatory && !this.isReadonly) {
            validators.push(Validators.required);
        }

        switch (field.type) {
            // TODO_DGS implementare metodo se necessario
            case 1:
            case 2:
            default:
                break;
        }
        return validators;
    }

    isDateNull (controlName : string) : boolean {
        const control = this.formGroup.get(controlName);
        return !control || !control.value;
    }
}
